import * as Yup from "yup";

export const formValidationSchema = Yup.object().shape({
  tgl_maintenance_request_master: Yup.string().required("Masukan tanggal"),
});
